import type { IconName, PhosphorIconName } from '@/components/atomic/icon'

import { Switch, type ToggleVariantType } from './base'

interface ToggleProps {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (checked: boolean) => void
  disabled?: boolean
  className?: string
  variant?: ToggleVariantType
  icon?: IconName | PhosphorIconName
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function Toggle({
  checked,
  defaultChecked = false,
  onChange,
  disabled = false,
  className,
  variant,
  icon,
}: ToggleProps) {
  return (
    <Switch
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={onChange}
      disabled={disabled}
      className={className}
      variant={variant}
      icon={icon}
    />
  )
}

Toggle.displayName = 'Toggle'
